import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { AuditItem, AuditDetailItem, AuditDetailObject } from '../../interface/StudyArea-Logs';

@Component({
  selector: 'app-data-grid-logs',
  templateUrl: './data-grid-logs.component.html',
  styleUrl: './data-grid-logs.component.scss',
})

export class DataGridLogsComponent implements OnChanges {
  @Input() auditList: any[] = [];
  auditListData: any[] = [];
  auditMessages: any[] = [];
  first = 0;
  auditSearchString: string = '';
  totalAuditRecords: number = 0;
  rowsPerPage = 10;
  rowsPerPageOptions = [5, 10, 20, 50];
  detailsColWidth: number = 0;
  updatedValueColWidth: number = 0;
  previousValueColWidth: number = 0;
  rows: number = 10;
  paginatorDropdownOptions: number[] = [5, 10, 20, 30, 50];
  @Output() sortFunction = new EventEmitter<any>();
  searchString: string = "";
  filteredHistoryLogsData: any[] = [];

  ngOnChanges(): void {
    if (this.auditList) {
      this.auditListData = this.auditList;
      this.auditMessages = this.convertAuditListData(this.auditListData);
      this.filteredHistoryLogsData = this.convertAuditListData(this.auditListData);
    }
  }

  convertAuditListData(auditListData: AuditItem[]): AuditItem[] {
    return auditListData.map((item: AuditItem) => {
      // If already converted, return as-is
      if (Array.isArray(item.auditDetails)) {
        return item;
      }

      const auditDetailsObj: AuditDetailObject = item.auditDetails;

      const convertedAuditDetails: AuditDetailItem[] = Object.keys(auditDetailsObj)
        .filter((key: string) => key !== '$id')
        .map((key: string) => ({
          $id: auditDetailsObj[key].$id,
          label: key,
          newValue: auditDetailsObj[key].newValue,
          oldValue: auditDetailsObj[key].oldValue
        }));

      return {
        ...item,
        auditDetails: convertedAuditDetails
      };
    });
  }

  formatLabel(key: string): string {
    return key
      .replace(/String/g, '')
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }

  onHistoryLogChange(value: string): void {
    if (!value?.trim()) {
      this.filteredHistoryLogsData = [...this.auditMessages];
      return;
    }
    this.searchString = value.toLowerCase();

    this.filteredHistoryLogsData =
      this.auditMessages.filter(item =>
        String(item?.licenseNumber ?? '').toLowerCase().includes(this.searchString) ||
        String(item?.licenseName ?? '').toLowerCase().includes(this.searchString) ||
        String(item?.clientName ?? '').toLowerCase().includes(this.searchString) ||
        String(item?.projectLocation ?? '').toLowerCase().includes(this.searchString)
      );
  }

}
